import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import BeenHereIcon from '@mui/icons-material/Beenhere';
import DoneIcon from '@mui/icons-material/DoneOutline';
import ForumIcon from '@mui/icons-material/Forum';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PeopleIcon from '@mui/icons-material/People';
import StarIcon from '@mui/icons-material/Star';
import SchoolIcon from '@mui/icons-material/School';
import SpeedIcon from '@mui/icons-material/Speed';
import TranslateIcon from '@mui/icons-material/Translate';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';

const HighlightIcon = ({highlight, style}) => {
  let icon;
  switch (highlight.title) {
    case 'MovementX Veteran':
      icon = <BeenHereIcon style={style} />;
      break;
    case '2000 Sessions Completed':
      icon = <HowToRegIcon style={style} />;
      break;
    case '1000 Sessions Completed':
      icon = <HowToRegIcon style={style} />;
      break;
    case '10+ Years as a Personal Trainer':
      icon = <HealthAndSafetyIcon style={style} />;
      break;
    case '5+ Years as a Personal Trainer':
      icon = <HealthAndSafetyIcon style={style} />;
      break;
    case '30+ Years of Experience':
      icon = <HealthAndSafetyIcon style={style} />;
      break;
    case '20+ Years of Experience':
      icon = <HealthAndSafetyIcon style={style} />;
      break;
    case '15+ Years of Experience':
      icon = <HealthAndSafetyIcon style={style} />;
      break;
    case '10+ Years of Experience':
      icon = <HealthAndSafetyIcon style={style} />;
      break;
    case '5+ Years of Experience':
      icon = <HealthAndSafetyIcon style={style} />;
      break;
    case '25+ Reviews':
      icon = <StarIcon style={style} />;
      break;
    case '50+ Reviews':
      icon = <StarIcon style={style} />;
      break;
    case 'Quick Response':
      icon = <SpeedIcon style={style} />;
      break;
    case 'Same-Day Service':
      icon = <EventAvailableIcon style={style} />;
      break;
    case 'Extended Availability':
      icon = <PermContactCalendarIcon style={style} />;
      break;
    case 'Telehealth Provider':
      icon = <AddToQueueIcon style={style} />;
      break;
    case 'Free Consult':
      icon = <MoneyOffIcon style={style} />;
      break;
    case 'Accepting New Patients':
      icon = <PersonAddIcon style={style} />;
      break;
    case 'Offers Free Consults':
      icon = <ForumIcon style={style} />;
      break;
    case 'Clinical Instructor':
      icon = <MedicalServicesIcon style={style} />;
      break;
    case 'Clinical Researcher':
      icon = <TroubleshootIcon style={style} />;
      break;
    case 'Board Certified Specialist':
      icon = <VerifiedIcon style={style} />;
      break;
    case 'Advanced Certifications':
      icon = <DoneIcon style={style} />;
      break;
    case 'Academic Professor':
      icon = <SchoolIcon style={style} />;
      break;
    case 'Community Advocate':
      icon = <PeopleIcon style={style} />;
      break;
    case 'Multilingual Provider':
      icon = <TranslateIcon style={style} />;
      break;
    case 'Local to the Area':
      icon = <WhereToVoteIcon style={style} />;
      break;
    case 'AgeProof Instructor':
      icon = <VerifiedUserIcon style={style} />;
      break;
    default:
      icon = <VerifiedIcon style={style}/>;
  }
  return icon;
};

export default HighlightIcon;